import { reactive } from 'vue'

// 正常メッセージデータ
type NormalMsgData = {
  // リソースキー
  key: string
}

// エラーメッセージ状態
type NormalMsgState = {
  // データ配列
  data: Array<NormalMsgData>
}

/**
 * 初期状態を取得する
 * @returns reactiveした初期状態
 */
const useNormalMsg = (): NormalMsgState =>
  reactive<NormalMsgState>({
    data: [],
  })

/**
 * キーから正常メッセージのデータに変換する
 * @param keys キー配列
 * @param state reactiveしたState
 */
const convertArrayData = (keys: Array<string>, state: NormalMsgState): void => {
  const list = state.data
  // データ削除
  list.splice(0)
  // キー登録
  keys.forEach((p) => {
    const data: NormalMsgData = {
      key: p,
    }
    list.push(data)
  })
}

/**
 * キーから正常メッセージのデータに変換する
 * @param key キー
 * @param state reactiveしたState
 */
const convertData = (key: string, state: NormalMsgState): void => {
  convertArrayData([key], state)
}

/**
 * 正常メッセージのデータをクリアする
 * @param state reactiveしたState
 */
const clearNormalMsg = (state: NormalMsgState): void => {
  state.data.splice(0)
}

export {
  NormalMsgState, //
  useNormalMsg, //
  convertData, //
  convertArrayData, //
  clearNormalMsg,
}
